export default "__VITE_ASSET__20e1d66e__"